<div class="dialog">
  <div class="dialog-header">
    <span class="dialog-title">{{ data.title }}</span>
    <button type="button" class="close-btn" (click)="close()" aria-label="Close">×</button>
  </div>

  <div class="field">
    <span class="field-label">Utsav</span>
    <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
      <mat-select
        panelClass="ac-select-panel"
        [disableOptionCentering]="true"
        [formControl]="utsavId"
        placeholder="Select utsav"
      >
        @for(utsav of data.utsavs; track utsav.utsavId){
        <mat-option [value]="utsav.utsavId">{{ utsav.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="dialog-actions">
    <button type="button" class="ac-secondary-btn" (click)="close()">Close</button>
    <button type="button" class="ac-primary-btn" [disabled]="!utsavId.value" (click)="submit()">
      Continue
    </button>
  </div>
</div>
